<template>
  <PageNavigation />
  <div class="margin-section">
      <div>
          <InsertImage titlePage="RECRUITMENT" titlePageJP="採用情報"/>
      </div>
      <div class="half-block-content">
        <div id="medical_office_worker">
            <h2 v-fade-in>医療事務の求人情報</h2>
            <div class="center">
                <img alt="Circle objects" src="@/assets/images/circle_objects.png" class="display-circle-obj" width="180" height="21.77" />
            </div>
            <div class="recruitment-status" v-fade-in>
              <!-- <span class="recruiting-badge">募集中</span> -->
              <span class="not-recruiting-badge">募集停止中</span>
            </div>
            <p v-fade-in>現在、人員の募集は行っておりません。</p>
            <!-- <div class="table-content" v-fade-in>
              <table>
                <tbody>
                  <tr>
                    <td>募集職種</td>
                    <td>受付・医療事務</td>
                  </tr>
                  <tr>
                    <td>仕事内容</td>
                    <td>
                      ・クリニック受付、会計<br>
                      ・パソコン入力(使用方法は指導します)<br>
                      ・レセプト<br>
                      ・検査補助<br>
                      ・院内整理
                    </td>
                  </tr>
                  <tr>
                    <td>雇用形態</td>
                    <td>正社員</td>
                  </tr>
                  <tr>
                    <td>給与</td>
                    <td>180,000円 ~ 260,000円</td>
                  </tr>
                  <tr>
                    <td>賞与</td>
                    <td>年2回 (計 4.0カ月分)</td>
                  </tr>
                  <tr>
                    <td>昇給</td>
                    <td>あり</td>
                  </tr>
                  <tr>
                    <td>必要な資格</td>
                    <td>
                      ・医療事務資格 あれば尚可<br>
                      ・普通自動運転免許 必須
                    </td>
                  </tr>
                  <tr>
                    <td>就業時間</td>
                    <td>
                      (1) 8時30分 ~ 18時45分 休憩150分<br>
                      (2) 8時30分 ~ 15時15分 休憩60分 (土曜日)
                    </td>
                  </tr>
                  <tr>
                    <td>休日等</td>
                    <td>週休二日制 (木、日、祝日)、年末年始・夏季休暇<br>有給休暇日数 10日 (6カ月経過後)</td>
                  </tr>
                  <tr>
                    <td>その他の労働条件</td>
                    <td>通勤交通費支給、雇用保険、労災保険、健康保険、厚生年金保険、退職金あり(勤続3年以上)</td>
                  </tr>
                  <tr>
                    <td>特記事項</td>
                    <td>お子様やご家庭の事情による急な休みにも柔軟に対応します</td>
                  </tr>
                </tbody>
              </table>
            </div> -->
        </div>
      </div>
  </div>
  <PageFooter />
</template>

<script>
import PageNavigation from '@/components/PageNavigation.vue';
import PageFooter from '@/components/PageFooter.vue';
import InsertImage from '@/components/InsertImage.vue';

export default {
  name: 'MedicalOfficeRecruitmentPage',
  components: {
    PageNavigation,
    PageFooter,
    InsertImage,
  },
  data() {
    return {
    };
  },
}
</script>

<style scoped>

.table-content {
  text-align: center;
  margin: 2em 0;
}

table{
  border-collapse: collapse;
  text-indent: initial;
  table-layout: auto;
  margin-left: auto;
  margin-right: auto;
  width: 90%;
}

table th,table td{
  color: #505050;
  border:solid 1px #ddd;
  text-align: left;
  padding: .8em .75em;
  vertical-align: top;
  display: table-cell;
  unicode-bidi: isolate;
  line-height: 1.3;
}

/* 一番左の列のセルにスタイルを適用 */
table td:first-child {
  background: #f7f7f7;
  border: 1px solid #ddd;
  color: #505050;
  text-align: center;
  white-space: nowrap;
  font-weight: bolder;
  width: 150px;
}

table th {
  color: #ddd;
  background: #032264;
  font-weight: bold;
}

.recruitment-status {
  text-align: center;
  margin: 1em 0;
}

.recruiting-badge {
  display: inline-block;
  background-color: #28a745;
  color: white;
  padding: 0.5em 1.5em;
  border-radius: 20px;
  font-weight: bold;
  font-size: 16px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.not-recruiting-badge {
  display: inline-block;
  background-color: #888888;
  color: white;
  padding: 0.5em 1.5em;
  border-radius: 20px;
  font-weight: bold;
  font-size: 16px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

@media (max-width: 768px) {
  table {
    width: 95%;
  }
  
  table td:first-child {
    width: 120px;
    font-size: 14px;
  }
  
  table td {
    font-size: 14px;
    padding: .4em .5em;
  }
  
  .recruiting-badge {
    font-size: 14px;
    padding: 0.4em 1.2em;
  }
}

</style>